"use strict";

function accordionListeners(params) {
  const accordions = document.querySelectorAll('.accordion__title');
  accordions.forEach(title => {
    const accordion = title.closest('.accordion');
    title.setAttribute('aria-expanded', accordion.classList.contains('accordion--active') ? 'true' : 'false');
  });
  accordions.forEach(title => {
    if(title.classList.contains('js-listener--added')) return;
    title.classList.add('js-listener--added');
    title.addEventListener('click', (e) => {
      e.preventDefault();
  
      const clickedTitle = e.target.closest('.accordion__title');
      const clickedAccordion = clickedTitle.closest('.accordion');
      const container = clickedAccordion.parentNode;
      const activeAccordion = container.querySelector('.accordion--active');
  
      if (activeAccordion && activeAccordion !== clickedAccordion) {
        activeAccordion.classList.remove('accordion--active');
        activeAccordion.querySelector('.accordion__title').setAttribute('aria-expanded', 'false');
      }
      const isActive = clickedAccordion.classList.contains('accordion--active');
  
      clickedAccordion.classList.toggle('accordion--active');
      clickedTitle.setAttribute('aria-expanded', (!isActive).toString());
    });
  });
}

accordionListeners();

window.accordionListeners = accordionListeners;